import React from 'react'

const LinkTextFooter = ({ Link, TextContent }) => (
    <a target="_blank" rel="noreferrer" href={Link}>
        <p className="letter-footer">{TextContent}</p>
    </a>
)

export default LinkTextFooter